module.exports = __webpack_public_path__ + "static/img/dragontiger2_esp.6c98b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/dragontiger2_esp.png
// module id = zhWr
// module chunks = 1